let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4TtK3")).then(() => parcelRequire('9JT0Q'));